'use strict';
import {runInjector} from '../../_libs/angular-utils/index';
import {StatelessStatusSelectorComponent} from './components/StatelessStatusSelector/StatelessStatusSelectorComponent';


const angular = require('angular');

module.exports = angular
  .module('app.components.selectors', [])
  .run(runInjector(StatelessStatusSelectorComponent))
  .service('selectorsService', require('./SelectorsService.js'))

  .service('ProjectsFilterMixin', require('./ProjectsFilterMixin.js'))
  .service('SelectorFilterMixin', require('./SelectorFilterMixin.js'))

  .controller('PersonnelSelectController', require('./PersonnelSelectController.js'))
  .controller('PrivatePersonnelSelectController', require('./PrivatePersonnelSelectController.js'))
  .controller('SelectController', require('./SelectController.js'))
  .controller('StatusRejectionDialogController', require('./status-selector-directive/StatusRejectionDialogController.js'))
;



// WEBPACK FOOTER //
// ./src/js/core-components/selectors/index.js